module.exports = "//d274d294w9cx2v.cloudfront.net/1eb54c75a36ed2ef3e5201521c94dc40b8afadd2/images/payPalBadge.png";